//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { IScope } from 'angular';
import React from 'react';
import { useSelector } from 'react-redux';

import { CenteredSpinner } from '@components/atoms/spinner/Spinner';
import makeAngularReactControllerWithScope from '@react-bridge/angular-react-widget-with-scope';
import { MediaTrackingContextProvider } from '@tracker/mediaTracking/contexts/MediaTrackingContextProvider';
import { useGetMediaTrackingSource } from '@tracker/mediaTracking/useGetMediaTrackingSource';
import { getRootCuid } from '@uia/details/selectors/getUIAReactPortItemDetails';
import { UIALabels } from '@uia/labels/UIALabels';
import { UIAContainer } from '@uia/layout/UIAContainer';
import { isDefined } from '@utils/filterPredicates';

export interface UniversalImageActionsLabelsProps {
  onCloseModal: () => void;
}

const UniversalImageActionsLabels = ({
  onCloseModal,
}: UniversalImageActionsLabelsProps) => {
  const source = useGetMediaTrackingSource();
  const cuid = useSelector(getRootCuid);

  return (
    <UIAContainer>
      {(() => {
        return isDefined(cuid) ? (
          <MediaTrackingContextProvider source={source}>
            <UIALabels cuid={cuid} onClose={onCloseModal} />
          </MediaTrackingContextProvider>
        ) : (
          <CenteredSpinner />
        );
      })()}
    </UIAContainer>
  );
};

angular.module('curalate').component('uiaLabels', {
  controller: makeAngularReactControllerWithScope((scope: IScope) => {
    return (
      <UniversalImageActionsLabels
        onCloseModal={() => scope.$emit('uia:modal:close')}
      />
    );
  }),
});
